import {styled} from "@mui/material";

export const AttachmentContainer = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: '0.4rem',
}));

export const AttachmentCardContainer = styled('div')(({theme}) => ({
    height: '9rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3.25rem 1rem 3.25rem 0.5rem',
    width: '100%',
    gap: '0.2rem',
    borderRadius: '0.5rem',
    background: '#F3F3FA',
    cursor: 'pointer',
    alignSelf: 'stretch',
    border: `0.1rem dashed ${theme.barekam.documents.order.product.borderColor}`,
}));

export const AttachmentRowContainer = styled('div')(() => ({
    background: '#F3F3FA',
    borderRadius: '0.5rem',
    height: 'unset',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '0.5rem 1rem 0.5rem 0.5rem',
    gap: '0.5rem',
}));

export const ParcelIconContainerAdornment = styled(AttachmentCardContainer)(() => ({
    position: 'absolute',
    top: '0.01rem',
    bottom: '-3.6rem',
    left: '-0.1rem',
    justifySelf: 'top'
}));

export const BarekamFileInputContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 'unset',
        height: 'unset',
        border: '1px dashed #CFCFE0',
        borderRadius: '0.5rem',
        background: '#FBFBFF',
        padding: '2.4rem 8.5rem',
        gap: '0.5rem',
        cursor: 'pointer',
    }
});